import PropTypes from "prop-types";
import React from "react";
import { Checkbox, Grid, Image, Loader } from "semantic-ui-react";
import { assetService } from "../../services";
import { assetTypeService } from "../../services/assetTypeService";

export default class AssetDetails extends React.Component {
    constructor(props) {
        super(props);

        this.getFullAssetDetails = this.getFullAssetDetails.bind(this);

        this.state = AssetDetails.getInitialState();
    }

    static getInitialState() {
        return {
            assetDetails: null,
            assetTypeDetails: null,
            assetImageData: null,
            error: null,
            imageError: null
        };
    }

    static getValueSafely(object, key, fallback = "") {
        return (object && object[key] !== undefined) ? object[key] : fallback;
    }

    componentDidMount() {
        if (this.props.assetId) {
            this.getFullAssetDetails();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.assetId !== prevProps.assetId) {
            if (this.props.assetId) {
                this.getFullAssetDetails();
            } else {
                this.setState(AssetDetails.getInitialState());
            }
        }
    }

    getFullAssetDetails() {
        this.setState(AssetDetails.getInitialState());

        assetService.read(this.props.assetId)
            .then((result) => {
                this.setState({ assetDetails: result.data });
                assetTypeService.read(result.data.assetTypeId)
                    .then((assetTypeResult) => {
                        this.setState({ assetTypeDetails: assetTypeResult.data });
                    })
                    .catch((err) => {
                        this.setState({ error: `Failed to fetch asset type details: ${err.message || err}` });
                    });
                
                assetService.getImage(this.props.assetId)
                    .then((imageResult) => {
                        this.setState({ assetImageData: imageResult.data });
                    })
                    .catch((err) => {
                        this.setState({ imageError: `Failed to fetch asset image: ${err.message || err}` });
                    });
            })
            .catch((err) => {
                this.setState({ error: `Failed to fetch asset details: ${err.message || err}` });
            });
    }

    renderAssetImage() {
        if (this.state.assetImageData) {
            return <Image src={`data:image/jpeg;base64,${this.state.assetImageData}`} className="asset-picture"/>;
        } else {
            return <div>No image available</div>;
        }
    }

    renderAssetDetails(details) {
        return (
            <Grid.Row>
                {details.map((column) => (
                    <Grid.Column width={column.width} key={column.key} className={column.className}>
                        {column.content.map((detail) =>
                            detail.loading ? (
                                <Loader active inline="centered" key={detail.key} />
                            ) : (
                                <p key={detail.key}>
                                    <strong>{detail.label}</strong>
                                    <br />
                                    {detail.value}
                                </p>
                            )
                        )}
                    </Grid.Column>
                ))}
            </Grid.Row>
        );
    }

    render() {
        const display = [
            {
                key: "asset_details_col_1",
                width: 2,
                content: [
                    {
                        key: "asset_name",
                        label: "Name",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'name', ''),
                        loading: !this.state.assetDetails
                    },
                    {
                        key: "asset_description",
                        label: "Description",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'description', ''),
                        loading: !this.state.assetDetails
                    },
                    {
                        key: "asset_type_name",
                        label: "Asset Type Name",
                        value: AssetDetails.getValueSafely(this.state.assetTypeDetails, 'name', ''),
                        loading: !this.state.assetTypeDetails
                    },
                    {
                        key: "asset_external_reference",
                        label: "External Reference",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'externalReference', ''),
                        loading: !this.state.assetDetails
                    }
                ]
            },
            {
                key: "asset_details_col_2",
                width: 2,
                content: [
                    {
                        key: "asset_number",
                        label: "Asset Number",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'assetNumber', ''),
                        loading: !this.state.assetDetails
                    },
                    {
                        key: "asset_serial_number",
                        label: "Serial Number",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'serialNumber', ''),
                        loading: !this.state.assetDetails
                    },
                    {
                        key: "asset_owner",
                        label: "Owner",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'owner', ''),
                        loading: !this.state.assetDetails
                    },
                    {
                        key: "asset_suspended",
                        label: "Suspended",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'suspended', false) ? 'True' : 'False',
                        loading: !this.state.assetDetails
                    }
                ]
            },
            {
                key: "asset_details_col_3",
                width: 7,
                content: [
                    {
                        key: "asset_notes",
                        label: "Notes",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'notes', ''),
                        loading: !this.state.assetDetails
                    },
                    {
                        key: "asset_barcode",
                        label: "Barcode",
                        value: AssetDetails.getValueSafely(this.state.assetDetails, 'uniqueBarcode', ''),
                        loading: !this.state.assetDetails
                    }
                ]
            },
            {
                key: "asset_details_col_4",
                width: 5,
                className: "issue-details-devider",
                content: [
                    {
                        key: "asset_image",
                        label: "Asset Photo",
                        value: this.renderAssetImage(),
                        loading: !this.state.assetDetails
                    }
                ]
            }
        ];

        return (
            <Grid>
                {!this.state.error ? (
                    this.renderAssetDetails(display)
                ) : (
                    <Grid.Column width={16} style={{ color: 'red' }}>
                        {this.state.error}
                    </Grid.Column>
                )}
            </Grid>
        );
    }
}

AssetDetails.propTypes = {
    assetId: PropTypes.string
};